/**
 * Created by Carsten Bühler
 * User: c.buehler on 23.04.2019
 * Copyright: xdot GmbH 2019
 */

'use strict';

import React, { useRef } from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, ListGroupItem } from 'external/react-bootstrap';
import Icon from './Icon';
import '../css/_details-list-item.scss';
import { ConfirmFormContainer, FormActions, translation } from 'plugin/liferay-widgets-react-web';
import NamedListWebApi from '../webapi/NamedListWebApi';
import LinesEllipsis from 'react-lines-ellipsis';

const DetailsListItem = React.forwardRef(({ item, list, children, onClickDelete }, ref) => {
    const FORM_DELETE_OBJECT = useRef('DeleteObject_' + item.__type + '_' + item.id);

    const _onClickDelete = (formData) => {
        FormActions.stopEditFormItem(FORM_DELETE_OBJECT.current);
        const entries = list.entries.filter(entry => !(entry.className === formData.className && formData.classPK === entry.classPK));
        NamedListWebApi.update({ ...list, entries });
    };

    const openDeleteForm = () => {
        FormActions.startEditFormItem(FORM_DELETE_OBJECT.current, {
            className: item.__type,
            classPK: item.id
        });
    };

    return (
        <ListGroupItem className="details-list-item" ref={ref}>
            {children}
            {
                onClickDelete &&
                <React.Fragment>
                    <ConfirmFormContainer
                        formId={FORM_DELETE_OBJECT.current}
                        title="Löschen"
                        Content={({ formData }) => ('Wollen Sie das Objekt wirklich aus der Liste entfernen?')}
                        editRequired={false}
                        onFormSubmit={_onClickDelete}
                    />
                    <Button
                        variant="link"
                        size="sm"
                        title="Löschen"
                        onClick={openDeleteForm}
                    >
                        <Icon name="x"/>{translation.trans('delete')}
                    </Button>
                </React.Fragment>
            }
        </ListGroupItem>
    );
});

DetailsListItem.propTypes = {
    item: PropTypes.object,
    list: PropTypes.object,
    onClickDelete: PropTypes.bool,
    children: PropTypes.any,
};

const DetailsListItemNameBox = props => {
    return (
        <div className="name-box" onClick={props.onClick}>
            {props.children}
        </div>
    );
};
const DetailsListItemTitle = props => {
    return (
        <LinesEllipsis
            text={props.children}
            maxLine="3"
            ellipsis="..."
            trimRight
            basedOn="letters"
        />
    );
};
const DetailsListItemStatusBox = props => {
    return (
        <div className="status-box">
            {props.children}
        </div>
    );
};
const DetailsListItemMeasurementBox = props => {
    return (
        <div className="measurements-box">
            {props.children}
        </div>
    );
};

const DetailsListItemEditBox = props => {
    return (
        <div className="edit-box">
            {props.children}
        </div>
    );
};

export {
    DetailsListItem,
    DetailsListItemNameBox,
    DetailsListItemTitle,
    DetailsListItemStatusBox,
    DetailsListItemEditBox,
    DetailsListItemMeasurementBox
};



// WEBPACK FOOTER //
// ./js/components/DetailsListItemComponents.jsx